"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const index_1 = require("./index");
function hardBreak() {
    return new HardBreak();
}
exports.hardBreak = hardBreak;
class HardBreak extends index_1.InlineNode {
    toJSON() {
        return {
            type: 'hardBreak',
            attrs: {
                text: '\n'
            }
        };
    }
}
exports.HardBreak = HardBreak;
//# sourceMappingURL=hard-break.js.map